import ViewSimilar from "../Components/Sub_Home/ViewSimilar";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Layout from "../Components/Layout/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as farHeart } from "@fortawesome/free-regular-svg-icons";
import { faHeart as fasHeart } from "@fortawesome/free-solid-svg-icons";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import { FacebookShareButton, WhatsappShareButton, FacebookIcon, WhatsappIcon, } from "react-share";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useWishlist } from "../Context/WishlistContext";
import { IconButton } from "@mui/material";
import Footer from "../Components/Layout/Footer";
import toast from "react-hot-toast";
import axios from "axios";
import Modal from "@mui/material/Modal";
import defaultImage from "../Assets/image_not_found.svg";
import insta from "../Assets/insta.png"
import "../Styles/ProductItem.css";

export const ProductItem1 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { l2_id } = location.state || {};
  const { slug: id } = useParams();
  const [cartItems, setCartItems] = useState([]);
  const [productData, setProductData] = useState(null);
  const [media, setMedia] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedSize, setSelectedSize] = useState(null);
  const [apiFailed, setApiFailed] = useState(false);
  const [descriptionDetails, setDescriptionDetails] = useState([]);
  const [activeSection, setActiveSection] = useState("");
  const [selectedColor, setSelectedColor] = useState(null);
  const [productId, setProductId] = useState(id);
  const [wishlistid, setWishlistId] = useState("");
  const [loading, setLoading] = useState(true);
  const { wishlist, removeFromWishlist, addToWishlist } = useWishlist();
  const [wishlistClicked, setWishlistClicked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [fullDescription, setFullDescription] = useState("");
  // const [isExpanded, setIsExpanded] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
  const [outOfStock, setOutOfStock] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const shareUrl = window.location.href;
  const contentRef = useRef(null);

  const accessToken = sessionStorage.getItem("auth");

  // const handleOpenModal = (description, key) => {
  //   setFullDescription(description);
  //   setModalTitle(key);
  //   setOpenModal(true);
  // };

  const handleVideoSelect = (mediaSrc, index) => {
    if (currentlyPlaying) {
      currentlyPlaying.pause();
      currentlyPlaying.currentTime = 0;
    }

    const videoElement = document.getElementById(`video-${index}`);

    if (videoElement) {
      videoElement
        .play()
        .then(() => {
          setCurrentlyPlaying(videoElement);
          setSelectedImage(mediaSrc);
        })
        .catch((error) => {
          console.error("Error playing video:", error);
        });
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleColorSelect = async (color) => {
    setSelectedColor(color);

    const updatedProductId = color.id;
    setProductId(updatedProductId);

    navigate(`/product/${updatedProductId}`);
  };

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    setOutOfStock(size.qty === 0);
  };

  const handleInstagramShare = () => {
    const instagramUrl = `https://www.instagram.com/`;
    window.open(instagramUrl, "_blank");
    toast.success("Instagram opened in a new tab. Paste the URL to share!");
  };

  const handleNativeShare = async () => {
    const shareData = {
      title: "Check this out",
      text: shareMessage,
      url: shareUrl,
      image: selectedImage,
    };

    try {
      if (window.innerWidth <= 768 && navigator.share) {
        await navigator.share(shareData);
      } else {
        setShowShareOptions(!showShareOptions);
      }
    } catch (err) {
      console.error("Sharing failed:", err.message);
    }
  };
  const getPrice = () => {
    if (selectedSize && selectedSize.price) {
      return selectedSize.price;
    }
    if (selectedColor && selectedColor.price) {
      return selectedColor.price;
    }
    return "N/A";
  };

  // useEffect(() => {
  //   if (productId) {
  //     setLoading(true);
  //     fetchProductDetails(productId);
  //     window.scrollTo(0, 0);
  //   }
  // }, [productId]);

  // useEffect(() => {
  //   setProductId(id);
  // }, [id]);

  useEffect(() => {
    setWishlistClicked(wishlist.includes(l2_id)); // Sync wishlist state
  }, [wishlist, l2_id]);

  const toggleWishlist = async () => {
    if (!accessToken) {
      toast.error("Please log in to add items to your wishlist.");
      return;
    }
  
    try {
      if (wishlistClicked) {
        await axios.delete(
          "https://tarunika.backendapihub.com/wishlist/wishlist/remove",
          {
            headers: { "access-token": accessToken },
            data: { productID: l2_id }, 
          }
        );
        removeFromWishlist(l2_id);
        setWishlistClicked(false);
        toast.success("Item removed from wishlist.");
      } else {
        await axios.post(
          "https://tarunika.backendapihub.com/wishlist/wishlist/add",
          { productvariationID: l2_id }, 
          { headers: { "access-token": accessToken } }
        );
        addToWishlist(l2_id);
        setWishlistClicked(true);
        toast.success("Item added to wishlist.");
      }
    } catch (error) {
      toast.error("Something went wrong with the wishlist update.");
    }
  };
  

  const fetchCartItems = async () => {
    if (!accessToken) return;
    try {
      const response = await axios.get(
        "https://tarunika.backendapihub.com/cart/show",
        {
          headers: {
            "access-token": accessToken,
          },
        }
      );
      if (response.status === 200) {
        if (Array.isArray(response.data.data)) {
          setCartItems(response.data.data);
        } else {
          console.error("Cart items data is not an array");
          setCartItems([]);
        }
      } else {
        console.error("Failed to fetch cart items");
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
      setCartItems([]);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  useEffect(() => {
    setProductId(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  useEffect(() => {
    const fetchProductDetails = async (productId) => {
      try {
        const response = await axios.get(
          `https://tarunika.backendapihub.com/product/detailview/${productId}`
        );

        const productData = response.data;
        setProductData(productData);

        // Set Wishlist ID
        setWishlistId(productData.data[0].id);

        // Handle out-of-stock condition
        const productQty = productData.data[0].qty;
        setOutOfStock(productQty === 0);

        // Parse description details
        const descriptionDetailsData =
          response.data.data[0].description_details;
        try {
          const parsedDetails = JSON.parse(descriptionDetailsData);
          setDescriptionDetails(parsedDetails);
          if (parsedDetails.length > 0) {
            setActiveSection(Object.keys(parsedDetails[0])[0].toLowerCase());
          }
        } catch (error) {
          console.error("Error parsing description details:", error);
        }

        // Handle variations
        const product = response.data.data[0];
        const variation1 = product.variation_1 || [];
        const variation2 = product.variation_2 || [];

        // Set selectedColor based on the URL's id parameter
        const currentColor = variation1.find(
          (color) => color.id === parseInt(productId)
        );
        if (currentColor) {
          setSelectedColor(currentColor);
        } else if (variation1.length > 0) {
          setSelectedColor(variation1[0]);
        }

        // Set selectedSize based on matching logic
        let currentSize;

        if (l2_id) {
          currentSize = variation2.find(
            (size) => size.size_id === parseInt(l2_id)
          );
        }

        if (currentSize) {
          setSelectedSize(currentSize);
        } else if (variation2.length > 0) {
          setSelectedSize(variation2[0]);
        }

        // Set media (images or videos)
        if (product.media && product.media.length > 0) {
          const mediaUrls = product.media.map((mediaSrc) => {
            return `https://tarunika.backendapihub.com/images/${mediaSrc}`;
          });
          setMedia(mediaUrls);
          setSelectedImage(mediaUrls[0]);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setApiFailed(true);
        setLoading(false);
      }
    };

    if (productId) {
      fetchProductDetails(productId);
    }
  }, [productId]);

  // const handleCheckPincode = async () => {
  //   // if (!accessToken) {
  //   //   setMessage("Please log in to check delivery options.");
  //   //   return;
  //   // }

  //   if (pincode.length !== 6 || isNaN(pincode)) {
  //     setMessage("Please enter a valid 6-digit pincode.");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `https://tarunika.backendapihub.com/address/getPincode?pincode=${pincode}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "access-token": accessToken,
  //         },
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       if (
  //         data.status.toLowerCase() === "success" &&
  //         data.message === "Pincode found"
  //       ) {
  //         setMessage("Delivery available for this pincode");
  //       } else {
  //         setMessage("Unfortunately, we do not ship to your pincode.");
  //       }
  //     } else {
  //       setMessage("Unfortunately, we do not ship to your pincode.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching pincode:", error);
  //     setMessage("Error: Unable to fetch data.");
  //   }
  // };

  useEffect(() => {
    const stars = document.querySelectorAll(".star");

    stars.forEach((star, index) => {
      star.addEventListener("click", function () {
        resetStars();
        for (let i = 0; i <= index; i++) {
          stars[i].classList.add("active");
        }
      });
    });

    function resetStars() {
      stars.forEach((star) => {
        star.classList.remove("active");
      });
    }

    return () => {
      stars.forEach((star) => {
        star.removeEventListener("click", resetStars);
      });
    };
  }, []);

  const addToCart = () => {
    if (!accessToken) {
      setErrorMessage(
        "Please register to add products to your cart. If you have already registered then click here to log in."
      );
      return;
    }

    if (!selectedColor || !selectedSize) {
      toast.error("Please select both color and size.");
      return;
    }

    if (outOfStock || selectedColor.qty === 0) {
      toast.error("This product is currently out of stock.");
      return;
    }

    const data = {
      l1_id: id,
      quantity: 1,
      size_id: selectedSize.size_name,
      color_id: selectedColor.id,
    };

    axios
      .post("https://tarunika.backendapihub.com/cart/add", data, {
        headers: {
          "access-token": accessToken,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message);
          fetchCartItems();
        } else {
          toast.error("Failed to add item to cart.");
        }
      })
      .catch((error) => {
        toast.error("Error adding item to cart.");
      });
  };

  if (loading) {
    return (
      <Layout>
        <div className="loader-container">
          <CircularProgress />
        </div>
      </Layout>
    );
  }

  // if (loading) {
  //   return <div className="loader-container">Loading...</div>;
  // }

  if (!productData) {
    if (apiFailed) {
      return (
        <Layout>
          <div className="ProductItem p-5">
            <div className="row m-0">
              <div className="col-lg-4 mb-3 mb-lg-0">
                <img src={defaultImage} alt="No images available" />
              </div>
              <div className="col-lg-8 mb-3 mb-lg-0">
                <p>
                  Product details are currently unavailable. please try again
                  later.
                </p>
              </div>
            </div>
          </div>
        </Layout>
      );
    } else {
      return (
        <Layout>
          <div className="ProductItem p-5">
            <div className="row m-0">
              <div className="col-lg-4 mb-3 mb-lg-0">
                <img src={defaultImage} alt="Loading image" />
              </div>
              <div className="col-lg-8 mb-3 mb-lg-0">
                <p>Loading image...</p>
              </div>
            </div>
          </div>
        </Layout>
      );
    }
  }

  const { product_name, sku, description, similar_products } =
    productData.data[0];
  const shareMessage = `Check this out:\n${product_name} ₹${getPrice()}`;

  const capitalizeFirstLetter = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  // const price = selectedSize ? selectedSize.price : "N/A";

  return (
    <Layout setCartItems={setCartItems} cartItems={cartItems} isNavbar={true}>
      <div className="item-top-section"></div>
      <section className="product_main">
        <div className="container">
          <div className="product_detail_section">
            <div className="row m-0">
              <div className="col-lg-6 mb-3 mb-lg-0 p-1">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-2 p-3">
                    <div
                      className="d-flex flex-md-column flex-sm-row flex-row justify-content-between"
                      style={{ gap: "10px" }}
                    >
                      {media && media.length > 0 ? (
                        media.map((mediaSrc, index) => {
                          const isVideo = /\.(mp4|webm|ogg)$/i.test(mediaSrc);
                          return (
                            <div
                              key={index}
                              className="media-container"
                              onClick={() => handleVideoSelect(mediaSrc, index)}
                              onMouseEnter={() => setSelectedImage(mediaSrc)}
                            >
                              {isVideo ? (
                                <video
                                  id={`video-${index}`}
                                  src={mediaSrc}
                                  controls
                                  preload="auto"
                                  muted
                                  // muted={selectedImage !== mediaSrc}
                                  loop={false}
                                />
                              ) : (
                                <img
                                  src={mediaSrc}
                                  alt={`product-img-${index}`}
                                  className="img-fluid"
                                />
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <img src={defaultImage} alt="No media available" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-sm-12 col-md-10 p-3">
                    <div className="d-flex flex-column align-items-center position-relative">
                      {selectedImage.endsWith(".mp4") ? (
                        <video
                          className=" img-fluid w-100"
                          src={selectedImage}
                          controls
                          autoPlay
                          loop
                        />
                      ) : (
                        <img
                          className=" img-fluid w-100"
                          src={selectedImage}
                          alt="Product"
                        />
                      )}

                      <div className="d-flex justify-content-between align-items-center">
                        <IconButton color="error">
                          <FontAwesomeIcon
                            icon={wishlistClicked ? fasHeart : farHeart}
                            className={`${wishlistClicked ? "clicked" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleWishlist();
                            }}
                          />
                        </IconButton>

                        <IconButton color="success">
                          <FontAwesomeIcon
                            icon={faShareAlt}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNativeShare();
                            }}
                          />
                        </IconButton>

                        {showShareOptions && window.innerWidth > 768 && (
                          <div
                            className="share-options"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <WhatsappShareButton
                              url={shareUrl}
                              title={shareMessage}
                            >
                              <WhatsappIcon size={36} round />
                            </WhatsappShareButton>
                            <FacebookShareButton
                              url={shareUrl}
                              quote={shareMessage}
                            >
                              <FacebookIcon size={36} round />
                            </FacebookShareButton>
                            <div
                              onClick={handleInstagramShare}
                              style={{ cursor: "pointer", textAlign: "center" }}
                              className="instagram-icon"
                            >
                              <img
                                src={insta}
                                alt="Instagram"
                                style={{  
                                  width: 36,
                                  height: 36,
                                  borderRadius: "50%",
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-3 mb-lg-0 p-3">
                <div className="small-none py-4" id="jkjk">
                  <div className="content-one">
                    <h1>{product_name}</h1>
                    <h6>
                      SKU : <span>{sku}</span>
                    </h6>
                    <p>{description}</p>
                  </div>

                  <div className="content-two d-flex flex-wrap gap-3 align-items-center my-3">
                    <h6>
                      {capitalizeFirstLetter(
                        productData.data[0].variation_1[0]?.name
                      )}
                    </h6>
                    <div className="color-options">
                      {productData.data[0].variation_1 &&
                      productData.data[0].variation_1.length > 0 ? (
                        productData.data[0].variation_1.map((color) => (
                          <a
                            key={color.id}
                            className={`item-btn ${
                              selectedColor && selectedColor.id === color.id
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => handleColorSelect(color)}
                          >
                            {color.l1_primary_filter}
                          </a>
                        ))
                      ) : (
                        <p>No variation available</p>
                      )}
                    </div>
                  </div>

                  <div className="content-two d-flex flex-wrap gap-3 align-items-center my-3">
                    <h6>
                      {capitalizeFirstLetter(
                        productData.data[0].variation_2[0]?.name
                      )}
                    </h6>
                    <div className="size-options">
                      {productData.data[0].variation_2 &&
                      productData.data[0].variation_2.length > 0 ? (
                        productData.data[0].variation_2.map((size) => (
                          <a
                            key={size.size_id}
                            className={`item-btn ${
                              selectedSize &&
                              selectedSize.size_id === size.size_id
                                ? "selected"
                                : ""
                            }`}
                            onClick={() => handleSizeSelect(size)}
                          >
                            {size.size_name}
                          </a>
                        ))
                      ) : (
                        <p>No variation available</p>
                      )}
                    </div>
                  </div>

                  <div
                    className="content-three d-flex flex-column my-3"
                    id="sdcp"
                  >
                    <span>₹ {getPrice()}</span>
                    <p className="m-0">(MRP INCLUSIVE OF ALL TAXES)</p>
                  </div>
                  <div className="d-flex flex-column gap-2 my-4">
                    {outOfStock || selectedSize?.qty === 0 ? (
                      <a
                        className="purchase-btn out-of-stock-btn disabled"
                        disabled
                      >
                        Out of Stock
                      </a>
                    ) : (
                      <a
                        className="purchase-btn cart-btn"
                        onClick={() => {
                          if (!outOfStock && selectedColor && selectedSize) {
                            addToCart();
                          }
                        }}
                      >
                        ADD TO CART
                      </a>
                    )}
                    {!outOfStock && errorMessage && (
                      <p className="error-message">
                        <Link
                          to="/login"
                          onClick={() => {
                            window.scrollTo(0, 0);
                          }}
                          style={{ color: "red" }}
                        >
                          {errorMessage}
                        </Link>
                      </p>
                    )}
                  </div>

                  <div className="content-four d-flex justify-content-start gap-4 align-items-center">
                    {descriptionDetails.map((detail, index) => {
                      const key = Object.keys(detail)[0];
                      const detailContent = Object.values(detail)[0];
                      return (
                        <h6
                          key={index}
                          id={key.toLowerCase()}
                          className={`open${key.toLowerCase()} m-0 ${
                            activeSection === key.toLowerCase() ? "active" : ""
                          }`}
                          onClick={() => setActiveSection(key.toLowerCase())}
                        >
                          {key}
                        </h6>
                      );
                    })}
                  </div>
                  <hr />
                  <div className="content-four-details mt-4" ref={contentRef}>
                    {descriptionDetails.map((detail, index) => {
                      const key = Object.keys(detail)[0];
                      const detailContent = Object.values(detail)[0];

                      const isList =
                        detailContent.includes("<li>") ||
                        detailContent.includes("<ul>");

                      return (
                        <div
                          key={index}
                          id={key.toLowerCase()}
                          className={`desc ${
                            activeSection === key.toLowerCase() ? "" : "d-none"
                          }`}
                          style={{
                            overflow: "hidden",
                            transition: "height 0.3s ease",
                            fontFamily: "Mulish",
                            fontSize: "16px",
                            fontWeight: "400",
                            lineHeight: " 25.76px",
                            textAlign: "left",
                          }}
                        >
                          {isList ? (
                            <ul
                              dangerouslySetInnerHTML={{
                                __html: detailContent,
                              }}
                            />
                          ) : (
                            <p
                              dangerouslySetInnerHTML={{
                                __html: detailContent,
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div>
        {similar_products && similar_products.length > 0 && (
          <ViewSimilar products={similar_products} />
        )}
      </div>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-content-Description">
          <h2 style={{ textTransform: "capitalize" }}>{modalTitle}</h2>
          <div dangerouslySetInnerHTML={{ __html: fullDescription }} />
          <button onClick={handleCloseModal} className="description-close-btn">
            Close
          </button>
        </div>
      </Modal>

      <Footer showBothDivs={false} />
    </Layout>
  );
};

export default ProductItem1;
